let isTouchscreen = null;

export function checkIsTouchscreen() {
    if (isTouchscreen === null) {
        isTouchscreen = window.matchMedia("(pointer: coarse)").matches;
    }
    return isTouchscreen;
}
